let OSS = require('ali-oss');
// import { getOssToken } from '../api.js';
// import { recordLog, getFileType } from '../lib/util.js';

function getFileType(data, fileName) {
  let extend = null;
  const name = fileName || data.name;
  if (name) {
    const fileNameIndex = name.lastIndexOf('.');
    if (fileNameIndex != -1) extend = name.substring(fileNameIndex + 1);
  }
  if (!extend) {
    const fileTypeIndex = data.type.lastIndexOf('/');
    extend = data.type.substring(fileTypeIndex + 1);
  }
  return extend && extend.toLowerCase() || '';
}

let buckets = {
  shanghai: {
    region: 'oss-cn-shanghai',
    bucket: 'pics-maiyizhi'
  },
  californian: {
    region: 'oss-us-west-1',
    bucket: 'californian'
  }
}

// const data = '<File Object>';
// or const data = new Blob('content');
// or const data = new OSS.Buffer('content'));
async function putObject (data, prefix, bucketName = 'californian', fileName) {
  console.log('putObject', data);
  const fileType = getFileType(data, fileName);
  try {
    // const credentials = await getCredentials(bucketName);
    const client = new OSS({
      region: buckets[bucketName].region,
      endpoint: 'https://oss-accelerate.aliyuncs.com',
      accessKeyId: 'LTAI4G8anJ7d4rbGaz4iKD14', //credentials.accessid,
      accessKeySecret: '0fzajEQVmeCts8ad6XOZIFYDChv9oS', //credentials.accesskey
      // stsToken: credentials.token,
      bucket: buckets[bucketName].bucket
    })

    let objectKey = prefix + randomString(32) + '.' + fileType;
    // const objectKey = prefix + formatTime() + '_' + randomString(32) + '.' + fileType;

    let result = await client.put(objectKey, data);
    console.log(result);
    if (result.res && result.res.status == 200) {
      console.log("url", result.url);
      return { url: result.url.replace('https://californian.oss-accelerate.aliyuncs.com', 'https://statics.imgkits.com'), key: objectKey, fileType: fileType };
    } else {
      // recordLog({ fileType, size: data.size, error: result ,userId:window.userStatus?window.userStatus.id:'没有id',email:window.userStatus?window.userStatus.email:'没有邮箱' }, 'upload_oss_sdk_error');
      return Promise.reject(result);
    }
  } catch (error) {
    // recordLog({ fileType, size: data.size, error ,userId:window.userStatus?window.userStatus.id:'没有id',email:window.userStatus?window.userStatus.email:'没有邮箱' }, 'upload_oss_sdk_error');
    if(error.message&&error.message.includes("timeout")){
      throw new Error("Network connection error. Please try uploading the file again later");
    }
    return Promise.reject(error);
  }
}

// let stsCache = {};
// const getCredentials = async function (bucket) {
//   // if (stsCache[bucket]) {
//   //   return stsCache[bucket];
//   // }
//   const data = await getOssToken(buckets[bucket].region);
//   stsCache[bucket] = data;
//   return data;
// }

function randomString(len) {
  len = len || 32;
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var maxPos = $chars.length;
  var pwd = '';
  for (let i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

function formatTime() {
  const date = new Date();
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();

  return [day, hour, minute].map(formatNumber).join('-');
}

function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : '0' + n;
}

export default putObject;